import { Box } from '@mantine/core';

export function SiestaBackground() {
  return (
    <>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source src="/sidebar-background.mp4" type="video/mp4" />
      </video>

      <Box
        pos="absolute"
        style={{
          inset: 0,
          backgroundColor: 'rgba(255, 119, 28, 0.7)',
          zIndex: 1,
        }}
      />
    </>
  );
}
